import React, { useMemo } from 'react';
import cn from 'bem-cn';

import { useGetLeaderboardTopQuery } from '../../../store';

import { Stack } from '../../../components/UI';
import { Leaderboard } from '../../../components/Leaderboard/Leaderboard';

import './MyProfileRating.scss';
import { useUserContext } from '../../../contexts';

const b = cn('my-profile-rating');

export const MyProfileRating: React.FC = () => {
    const { data: leaders } = useGetLeaderboardTopQuery();
    const { user } = useUserContext();

    const getLeadersWithUser = useMemo(() => {
        return leaders || [];
    }, [leaders]);

    if (!user.publicId) {
        return null;
    }

    return (
        <Stack className={b()} spacing={24}>
            <Stack direction="row" justifyContent="space-between" align-items="center" className={b('header')}>
                <h2>Топ 100 лидеров</h2>
            </Stack>
            <Leaderboard leaders={getLeadersWithUser} currentUserPublicId={user.publicId} />
        </Stack>
    );
};
